import { VfAlert } from "@bvite/components/alert";

export default [VfAlert];
